import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/cogniflock_logo_full.svg";

const PasswordResetConfirmation = () => {
  const location = useLocation();
  const email = location.state?.email || "your email address";

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
      <div className="w-full max-w-sm p-6 flex flex-col gap-10">
        <img src={logo} alt="Logo" className="h-9" />
        <div className="relative w-full flex flex-col gap-3">
          <div className="w-full max-w-md flex flex-col gap-4 p-6 bg-white-f border border-grey-20 rounded-xl shadow-sm">
            <h2 className="text-xl  font-normal text-black-0">
              Password reset email sent
            </h2>
            <p className="text  font-normal text-grey-60">
              An email has been sent to{" "}
              <span className="font-semibold text-black-0">{email}</span> with
              instructions to reset your password.
            </p>
            <Link
              to="/login"
              className="w-full py-2 px-4 bg-white-f border border-grey-20 text-brand text-sm text-center  font-semibold tracking-wide rounded-md hover:grey-30-10 transition"
            >
              Back to Sign In
            </Link>
          </div>
          {/* Decorative lines */}
          <div className="absolute -top-20 -bottom-8 -left-2 w-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_top,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -top-20 -right-2 -bottom-8 w-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_top,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -top-2 -right-20 -left-20 h-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -bottom-2 -right-20 -left-20 h-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)]"></div>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetConfirmation;
